import Cookies from 'js-cookie';
import { HAS_DOCUMENT } from '@eventbrite/legacy-eds.utils/dom';
import { LOCATION_COOKIE, LOCATION_COOKIE_OPTIONS } from '../constants';
import { LocationCookie } from '../types';

// See https://docs.google.com/document/d/1Vg-kyxM34gw71vw_5dLcfzFRhzM3scQ3FKtYUlWXLSA/edit?usp=sharing
export const setLocationData = (locationData: LocationCookie) => {
    if (HAS_DOCUMENT) {
        Cookies.set(LOCATION_COOKIE, JSON.stringify(locationData), LOCATION_COOKIE_OPTIONS);
    }
};

// See https://docs.google.com/document/d/1Vg-kyxM34gw71vw_5dLcfzFRhzM3scQ3FKtYUlWXLSA/edit?usp=sharing
export const getLocationData = (): LocationCookie | null => {
    if (HAS_DOCUMENT) {
        const cookie = Cookies.get(LOCATION_COOKIE);
        if (cookie) {
            try {
                return JSON.parse(cookie);
            } catch (e) {
                return null;
            }
        }
    }

    return null;
};
